export const ADMIN_HOSTS = new Set([
  'admin.datacord.com',
  'admin.staging.datacord.com',
  'admin.localhost',
]);
export const APP_HOSTS = new Set([
  'app.datacord.com',
  'app.staging.datacord.com',
]);

export type WebsiteSurface = 'staff' | 'app' | 'local';

export function getWebsiteSurface(): WebsiteSurface {
  if (typeof window === 'undefined') return 'local';
  const host = window.location.hostname;
  if (ADMIN_HOSTS.has(host)) return 'staff';
  if (APP_HOSTS.has(host)) return 'app';
  return 'local';
}

export function isStaffAdminHost(): boolean {
  return getWebsiteSurface() === 'staff';
}

export function isAppProductHost(): boolean {
  return getWebsiteSurface() === 'app';
}

export function signInPath(): string {
  return isStaffAdminHost() ? '/admin/sign-in' : '/sign-in';
}

export function isStaffAuthPath(pathname: string): boolean {
  return pathname.startsWith('/admin/sign-in') || pathname.startsWith('/admin/oauth');
}

export function adminPublicUrl(): string {
  if (typeof window !== 'undefined' && window.location.hostname === 'admin.staging.datacord.com') {
    return 'https://admin.staging.datacord.com';
  }
  return 'https://admin.datacord.com';
}

export function appPublicUrl(): string {
  if (typeof window !== 'undefined' && window.location.hostname === 'admin.staging.datacord.com') {
    return 'https://app.staging.datacord.com';
  }
  return 'https://app.datacord.com';
}

export function staffAdminDestination(path = '/admin', search = '', hash = ''): string {
  const nextPath = path.startsWith('/admin') ? path : '/admin';
  return `${adminPublicUrl()}${nextPath}${search}${hash}`;
}

export function getStaffToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('adminAccessToken');
}

export function freshStaffToken(): string | null {
  const token = getStaffToken();
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    if (payload?.typ !== 'staff') return null;
    if (payload.exp && payload.exp * 1000 <= Date.now()) return null;
    return token;
  } catch {
    return null;
  }
}

export function setStaffToken(token: string | null) {
  if (typeof window === 'undefined') return;
  if (!token) {
    localStorage.removeItem('adminAccessToken');
    localStorage.removeItem('adminUser');
  } else {
    localStorage.setItem('adminAccessToken', token);
  }
}

export function getStaffUser(): { email?: string; firstName?: string; lastName?: string; role?: string } | null {
  if (typeof window === 'undefined') return null;
  try {
    return JSON.parse(localStorage.getItem('adminUser') || 'null');
  } catch {
    return null;
  }
}

export function pipelineAuthToken(): string | null {
  return getStaffToken() || localStorage.getItem('accessToken');
}
